import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-video-cmodel',
  standalone: false,
  templateUrl: './video-cmodel.html',
  styleUrl: './video-cmodel.scss'
})
export class VideoCmodel {
  @Input() qmessage: string ="";
  @Output() emitCService = new EventEmitter<number>();

  continue() { this.emitCService.emit(0); }
  recheck() { this.emitCService.emit(1); }
}
